import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import moment from "moment";
import useTable from "../useTableScroll2";
import { formatBytes } from "../../util/varios";
import { Dimmer } from "../spinner";
import notificationGet from "../eventEmitter";
import eventEmitter from "../eventEmitter";

const GenerarBackup = (props) => {
    const op = require("../../modulos/datos");
    const token = localStorage.getItem("jwtToken");
    const organizacion = JSON.parse(localStorage.getItem("riforganizacion"));
    const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const cmbBaseDatos = useRef();
    const cmbFormato = useRef();
    const cmbTipo = useRef();

    const headCells = [
        { label: "NOMBRE", textAlign: "center", with: 300 },
        { label: "TAMAÑO", textAlign: "center", with: 100 },
        { label: "FECHA", textAlign: "center", with: 100 },
        { label: "DESCARGAR", textAlign: "center", with: 50 },
        { label: "ELIMINAR", textAlign: "center", with: 50 },
    ];

    const { TblContainer, TblHead, } = useTable(headCells);

    const [lista, setLista] = useState([]);
    const [directorios, setDirectorios] = useState([]);

    const [visibleBtn, setVisibleBtn] = useState("visible");
    const [body, setBody] = useState(null);
    const [baseDatos, setBaseDatos] = useState([]);
    const [habilitado, setHabilitado] = useState(true);
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [mensajesino, setMensajesino] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [activate, setActivate] = useState(false);
    const [botones, setBotones] = useState({
        incluir: false,
        aceptar: true,
        cancelar: true,
    });

    const [database, setDataBase] = useState();

    const onChangeSelect = (e) => {
        if (e.target.value === "") {
            setDataBase();
        } else {
            console.log(baseDatos[parseInt(e.target.value)])
            setDataBase(baseDatos[parseInt(e.target.value)]);
            getFTP(baseDatos[parseInt(e.target.value)].nombre);
        }
    };

    const onChangeValidar = () => {
        let sigue = true;
        if (!botones.incluir) {
            if (cmbBaseDatos.current.value === "") {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación",
                    texto: "debe seleccionar una base de datos",
                    icono: "informacion",
                });
                sigue = false;
                cmbBaseDatos.current.focus();
            }
        }

        if (lista.length >= 5) {
            setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto:
                    "ya alcanzo el limite de respaldos, debe eliminar uno de los archivos para poder generar uno nuevo.",
                icono: "informacion",
            });
            sigue = false;
        }

        if (sigue) {
            setBody({
                database: database,
                formato: cmbFormato.current.value,
                tipo: cmbTipo.current.value,
                fechasistema: moment.utc(fechaSistema).format("DD-MM-YYYY"),
            });

            let msg = "";
            if (!botones.incluir) {
                msg = "Esta Seguro de Generar el Respaldo.";
            }

            setMensajesino({
                mostrar: true,
                titulo: "Confirmación.",
                texto: msg,
                icono: "confirmacion",
            });
        }
    };


    const procesarRegistro = () => {
        /*   setActivate(true);
           */
        //const ws = new WebSocket('wss://sistema.opensiap.com.ve/api/ws');
        const ws = new WebSocket(`${op.conexionbackup}`);

        ws.onopen = () => {
            console.log('Connected to WebSocket server');
            ws.send(JSON.stringify(body));
        };

        ws.onmessage = (event) => {
            console.log(`Message from server: ${event.data}`);
            const response = JSON.parse(event.data);

            eventEmitter.emit('updateNotifications');
           
            /*  if (response.message && response.message.includes('Backup created successfully')) {
                setMensaje({
                    mostrar: true,
                    titulo: "Éxito.",
                    texto: `Proceso ejecutado correctamente para la base de datos ${response.databaseName}`,
                    icono: "exito",
                });
                console.log(response);
                getFTP(response.databaseName);
            } else if (response.message && response.message.includes('Error en el proceso de respaldo')) {
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: `Error al crear el respaldo para la base de datos ${response.databaseName}`,
                    icono: "error",
                });
            } */
            setActivate(false);
            ws.close()
        };

        ws.onclose = () => {
            console.log('Disconnected from WebSocket server');
            setActivate(false);

        };

        ws.onerror = (error) => {
            console.error(`WebSocket error: ${error.message}`);
            setMensaje({
                mostrar: true,
                titulo: "Error",
                texto: "Error de conexión WebSocket",
                icono: "error",
            });
            setActivate(false);
        };
    };


    const handleCloseSi = () => {
        setActivate(false);
        setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
        procesarRegistro();
    };

    const seleccionarBasedeDatos = () => {

        let campos = "*";
        let nomtab = "basedatos";
        let orden = 'idbasedatos';
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        setActivate(true);

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    setBaseDatos(response.data);
                }
            })
            .catch(function (error) {
                /* setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                }); */
            })
            .finally(() => setActivate(false));
    };

    const onBotones = (op) => (e) => {
        e.preventDefault();

        if (op !== 6) {
            setVisibleBtn("hidden");
        } else {
            setVisibleBtn("visible");
        }

        if (op === 1) {
            setHabilitado(false);
            setBotones({
                incluir: false,
                aceptar: false,
                cancelar: false,
            });
            cmbBaseDatos.current.focus();
        } else if (op === 5) {
            onChangeValidar();
        } /* else if (op === 6) {
      blanquear();
    } */
    };

    /*   const blanquear = () => {
      if (props.menu === "sistema") {
        cmbBaseDatos.current.value = "";
      }
  
      setActivate(false);
      setBody(null);
      setHabilitado(true);
      setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
      setVisibleBtn("visible");
      setBotones({
        incluir: false,
        aceptar: true,
        cancelar: true,
      });
    };
   */
    const getFTP = (folder) => {
        console.log(folder)
        setActivate(true);
        let endpoint = `${op.conexion}/api/configuracion/allbackud?dir=${folder}`;
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    setLista(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(() => setActivate(false));
    };

    const getDescargar = (ruta, file) => {
        setActivate(true);
        let endpoint = `${op.conexion}/api/configuracion/descargarbackud?ruta=${ruta}&archivo=${file}`;
        axios
            .get(endpoint, {
                responseType: "arraybuffer",
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${file}`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => setActivate(false));
    };

    const eliminar = (ruta) => {
        setActivate(true);
        let endpoint = `${op.conexion}/api/configuracion/eliminarbackud?ruta=${ruta}`;
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then((response) => {
                if (response.status === 200) {
                    getFTP(database.nombre);
                    setMensaje({
                        mostrar: true,
                        titulo: "Exito.",
                        texto: response.data,
                        icono: "exito",
                    });
                }
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => setActivate(false));
    };

    useEffect(() => {
        seleccionarBasedeDatos();
    }, []);

    useEffect(() => {

        if (baseDatos.length > 0) {
            cmbBaseDatos.current.value = 0;
            setDataBase(baseDatos[0]);
            getFTP(baseDatos[0].nombre);
        }

    }, [baseDatos]);

    return (
        <div style={{ height: "100%", width: "100%" }}>
            <div className="col-md-12 mx-auto row">
                <div className="col-md-12 py-2 row card mx-auto">
                    <div className="col-md-12 row mx-auto rounded py-2  border-azul px-0 ">

                        <div className="input-group mb-3 input-group-sm col-sm-3 my-auto">
                            <label className="input-group-text" id="inputGroup-sizing-sm">
                                Base de Datos:
                            </label>
                            <select
                                className="form-select"
                                aria-label="Default select example col-md-3"
                                name="conexion"
                                /*      disabled={habilitado} */
                                ref={cmbBaseDatos}
                                onChange={onChangeSelect}
                            >
                                {baseDatos &&
                                    baseDatos.map((item, index) => (
                                        <option key={index} value={index}>
                                            {item.nombre.toUpperCase()}
                                        </option>
                                    ))}
                            </select>
                        </div>

                        <div className="input-group mb-3 input-group-sm col-sm-3 my-auto">
                            <label className="input-group-text" id="inputGroup-sizing-sm">
                                FORMATO:
                            </label>
                            <select
                                className="form-select"
                                aria-label="Default select example col-md-4"
                                name="formato"
                                /*   disabled={habilitado} */
                                ref={cmbFormato}
                            >
                                <option value={"c"}>CUSTOM</option>
                                <option value={"p"}>PLAIN</option>
                            </select>
                        </div>
                        <div className="input-group mb-3 input-group-sm col-sm-3 my-auto">
                            <label className="input-group-text" id="inputGroup-sizing-sm">
                                TIPO:
                            </label>
                            <select
                                className="form-select"
                                aria-label="Default select example col-md-4"
                                name="tipo"
                                /*       disabled={habilitado} */
                                ref={cmbTipo}
                            >
                                <option value={"backup"}>BACKUP</option>
                                <option value={"sql"}>SQL</option>
                            </select>
                        </div>

                        <div className="col-sm-3 my-auto">
                            <button
                                disabled={botones.incluir}
                                onClick={onBotones(5)}
                                className="btn btn-sm mx-1 btn-primary rounded-pill"
                                style={{ height: "27px" }}
                                title="Generar Respaldo"
                            >
                                <i style={{ fontSize: "9px" }} className="fas fa-plus">
                                    {" "}
                                    Generar Respaldo
                                </i>{" "}
                            </button>
                        </div>



                    </div>
                </div>

                <div className="row col-md-12 mx-auto px-0">
                    <TblContainer
                        container={{
                            maxHeight: 300,
                            minHeight: 300,
                            width: "100%",
                            overflow: "auto",
                        }}
                    >
                        <TblHead />
                        <tbody>
                            {lista &&
                                lista.map((item, index) => (
                                    <tr
                                        style={{
                                            cursor: "pointer",
                                        }}
                                        key={index}
                                        onClick={() => {
                                            if (item.type === "dir") {
                                                let dire = directorios;
                                                dire.push(item.route);
                                                setDirectorios(dire);
                                                getFTP(item.route);
                                            } /* else {
                                getDescargar(item.route, item.name);
                              } */
                                        }}
                                    >
                                        <td
                                            className="align-baseline letra-tabla-td text-start"
                                            style={{ width: 100 }}
                                        >
                                            {item.type === "dir" ? (
                                                <i className="fas fa-folder">{" " + item.name}</i>
                                            ) : (
                                                item.name
                                            )}
                                        </td>
                                        <td
                                            className="align-baseline letra-tabla-td text-right"
                                            style={{ width: 40 }}
                                        >
                                            {formatBytes(item.size)}
                                        </td>
                                        <td
                                            className="align-baseline letra-tabla-td text-center"
                                            style={{ width: 100 }}
                                        >
                                            {moment.utc(item.date).format("DD-MM-YYYY")}
                                        </td>
                                        <td
                                            className="align-baseline letra-tabla-td text-center"
                                            style={{ width: 10 }}
                                        >
                                            {item.type !== "dir" && (
                                                <button
                                                    className="btn btn-sm  btn-info rounded-circle ml-2"
                                                    onClick={() => getDescargar(item.route, item.name)}
                                                >
                                                    <i className="fas fa-download"></i>
                                                </button>
                                            )}
                                        </td>
                                        <td
                                            className="align-baseline letra-tabla-td text-center"
                                            style={{ width: 10 }}
                                        >
                                            {item.type !== "dir" && (
                                                <button
                                                    className="btn btn-sm  btn-danger rounded-circle ml-2"
                                                    onClick={() => eliminar(item.route)}
                                                >
                                                    <i className="fas fa-trash"></i>
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </TblContainer>
                </div>
            </div>

            <Dimmer active={activate} inverted>

            </Dimmer>

            <Mensaje
                mensaje={mensaje}
                onHide={() =>
                    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
                }
            />
            <MensajeSiNo
                mensaje={mensajesino}
                onHideNo={() =>
                    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
                }
                onHideSi={handleCloseSi}
            />
        </div>
    );
};
export default GenerarBackup;
